import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import { TaskPriority, TaskStatus } from "../../Tasks/Types";
import { AdvisorId, Custodian, } from "../../Types";
import ValidationError from "../../ZodError";
import { TransitionType, VirtualSubtask } from "../Types";
import { transitionsUrl } from "./urls";
export const PostTransitionRequest = z.object({
    title: z.string(),
    description: z.string().optional(),
    transitionType: TransitionType,
    serviceTeamId: z.string().optional(),
    advisor: z.array(AdvisorId),
    assignee: z.string(),
    dueDate: z.string(),
    custodian: Custodian,
    taskStatus: TaskStatus,
    taskPriority: TaskPriority,
    virtualSubtasks: z.array(VirtualSubtask),
});
export const PostTransitionResponseSchema = z.object({
    transitionId: z.string(),
});
export default async function postTransition(request, idempotencyKey, config) {
    const { data } = await axios.post(transitionsUrl(), request, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            "Content-Type": "application/json",
            "Idempotency-key": idempotencyKey,
            Version: "20250617",
        },
    });
    const decoded = PostTransitionResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[postTransition] returned unexpected data.";
        errorLog(postTransition.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postTransition.js.map